import { deprecatedTrack, trackEvent } from "./analytics";
import config from "./config";
import { isServer } from "./global";
import Cookies from "js-cookie";

export const resetIntercom = () => {
  if (isServer()) {
    return;
  }

  if (window && window.Intercom) {
    window.Intercom("shutdown");
    deprecatedTrack("intercom_shutdown");
  }
};

export const intercomReady = () => {
  if (isServer()) {
    return;
  }

  if (window && window.Intercom) {
    return true;
  }

  return false;
};

export const rebootIntercom = () => {
  if (isServer()) {
    return;
  }

  // Ensure intercom ids are removed in case the Intercom Javascript hasn't loaded yet
  Cookies.remove(`intercom-session-${config.INTERCOM_APP_ID}`);
  Cookies.remove(`intercom-id-${config.INTERCOM_APP_ID}`);

  if (window && window.Intercom) {
    // Ensure any existing intercom session is shutdown
    window.Intercom("shutdown");
    window.Intercom("boot", {
      app_id: config.INTERCOM_APP_ID,
      custom_launcher_selector: ".openIntercom",
      vertical_padding: 60
    });
    window.Intercom("onShow", () => {
      trackEvent("open_intercom");
    });
  }
};

export const showIntercom = () => {
  if (isServer()) {
    return;
  }

  if (window && window.Intercom) {
    window.Intercom("show");
  }
};

export const showNewMessageIntercom = ({ message }: { message: string }) => {
  if (isServer()) {
    return;
  }

  if (window && window.Intercom) {
    window.Intercom("showNewMessage", message);
  }
};

export const onHideIntercom = (onHide: () => void) => {
  if (isServer()) {
    return;
  }

  if (window && window.Intercom && onHide) {
    window.Intercom("onHide", onHide);
  }
};

export const onShowIntercom = (onShow: () => void) => {
  if (isServer()) {
    return;
  }

  if (window && window.Intercom && onShow) {
    window.Intercom("onShow", onShow);
  }
};

export const updateIntercom = ({
  intercomId,
  email,
  firstName,
  lastName,
  accountId,
  intercomUserHash,
  digitalMarketing = false
}: {
  intercomId: string;
  email: string;
  firstName: string;
  lastName: string;
  accountId: string;
  intercomUserHash: string;
  digitalMarketing?: boolean;
}) => {
  if (isServer()) {
    return;
  }

  if (window && window.Intercom) {
    window.Intercom("update", {
      user_id: intercomId,
      email,
      name: firstName + " " + lastName,
      account_id: accountId,
      digital_marketing: digitalMarketing,
      user_hash: intercomUserHash
    });
    deprecatedTrack("intercom_update");
  } else {
    deprecatedTrack("intercom_update_window_unavailable");
  }
};

export const updateUser = ({
  intercomId,
  email
}: {
  intercomId: string;
  email: string;
}) => {
  if (isServer()) {
    return;
  }

  if (window && window.Intercom) {
    window.Intercom("update", {
      user_id: intercomId,
      email
    });
    deprecatedTrack("intercom_update_user");
  } else {
    deprecatedTrack("intercom_update_user_window_unavailable");
  }
};
